<ng-container *ngIf="showNetDelta">
  <span
    class="change-request-delta"
    [ngClass]="netDeltaValue >= 0 ? 'delta-positive' : 'delta-negative'">
    {{ netDeltaValue >= 0 ? '+' : '' }}{{ valueFn ? valueFn(netDeltaValue) : netDeltaValue }}
  </span>
</ng-container>

<ng-container *ngIf="!showNetDelta">
  <ng-container *ngIf="isChangeRequest; else default">
    <ng-container *ngIf="!showDiff(fieldName); else diff">
      {{ valueFn ? valueFn(getFieldToDisplay(fieldName)) : getFieldToDisplay(fieldName) }}
    </ng-container>
  </ng-container>
</ng-container>

<ng-template #diff>
  <span class="change-request-diff">
    <span
      class="change-request-old"
      [ngClass]="{ 'change-request-old-highlight': highlightColors }">
      {{ valueFn ? valueFn(changes?.[fieldName]?.old) : changes?.[fieldName]?.old }}
    </span>
    <span
      class="change-request-new"
      [ngClass]="{ 'change-request-new-highlight': highlightColors }">
      {{ valueFn ? valueFn(changes?.[fieldName]?.new) : changes?.[fieldName]?.new }}
    </span>
  </span>
</ng-template>

<ng-template #default>
  {{ valueFn ? valueFn(getFieldValue()) : getFieldValue() }}
</ng-template>
